import { registerQuery } from 'data-fetching-client';
import { searchCrm } from 'email-management-lib/Shared/apis/crmSearch';
export const CRM_SEARCH = registerQuery({
  fieldName: 'emailCrmSearch',
  args: ['requestBody'],
  fetcher({
    requestBody
  }) {
    return searchCrm(requestBody);
  }
});